import React from 'react';

export const ReadyToUseASEStationMessage: React.FC = () => {
  return (
    <span>
      You can use{' '}
      <a
        href="https://azure.microsoft.com/en-us/features/storage-explorer/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Azure Storage Explorer
      </a>{' '}
      to upload/download files
    </span>
  );
};
